<template>
    <FormControl
        :error="
            errors?.getValidationError(
                RequestBodyKeyEnum.App_Availability_DateSpecificHours,
            )
        "
    >
        <div class="space-y-16">
            <SingleDateSpecificHoursForm
                v-for="(dateSpecificHours, index) in localDateSpecificHours"
                :key="dateSpecificHours.id"
                :dateSpecificHours="dateSpecificHours"
                :index="index"
                @onDelete="handleRemoveDateSpecificHours($event.id)"
            />

            <div class="flex justify-end mt-4">
                <Button
                    type="button"
                    @click="handleAddDateSpecificHours()"
                    iconName="plus"
                    color="light"
                    size="small"
                >
                    Add date
                </Button>
            </div>
        </div>
    </FormControl>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import Availability from '@/App/Availability/Entity/Availability'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import SingleDateSpecificHoursForm from '@/App/Availability/Component/SingleDateSpecificHoursForm.vue'
    import { type DateSpecificHoursType } from '@/Shared/AutoGenerated/Main'
    import Button from '@/Shared/Component/Button.vue'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        availability: {
            type: Object as PropType<Availability | null>,
            default: null,
        },
        errors: {
            type: Object as PropType<ApiFormErrors>,
            required: true,
        },
    })

    const localDateSpecificHours = ref<DateSpecificHoursType[]>(
        props.availability?.dateSpecificHours ?? [],
    )

    const handleAddDateSpecificHours = () => {
        localDateSpecificHours.value = [
            ...localDateSpecificHours.value,
            Availability.newDateSpecificHours(),
        ]

        localDateSpecificHours.value = [...localDateSpecificHours.value]
    }

    const handleRemoveDateSpecificHours = (id: string) => {
        localDateSpecificHours.value = localDateSpecificHours.value.filter(
            (dateSpecificHours: DateSpecificHoursType) => {
                return dateSpecificHours.id !== id
            },
        )
    }
</script>
